module.exports = vendor_a5b8e5c5e52423f0a98d;